import { render, staticRenderFns } from "./affiliate-referral-user.vue?vue&type=template&id=97eb14c2&scoped=true&"
import script from "./affiliate-referral-user.vue?vue&type=script&lang=js&"
export * from "./affiliate-referral-user.vue?vue&type=script&lang=js&"
import style0 from "./affiliate-referral-user.vue?vue&type=style&index=0&id=97eb14c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97eb14c2",
  null
  
)

export default component.exports